/* eslint-disable no-console */
import {window} from '../app/exec-env'

let _enabled = undefined
const storage = window.sessionStorage
const storename = `sessionStorage`

export const enabled = () => {
  if (typeof(_enabled) !== `undefined`) return _enabled
  if (typeof(storage) === `undefined`) {
    _enabled = false
    return _enabled
  }
  try {
    storage.setItem(storename, storename)
    _enabled = (storage.getItem(storename) === storename)
    storage.removeItem(storename)
  }
  catch(e) {
    console.log(`${storename} exception: ${e.message}`)
    _enabled = false
  }
  return _enabled
}

export const getItem = name => {
  if (!enabled) return undefined
  try {
    return storage.getItem(name)
  }
  catch(e) {
    console.log(`${storename} exception: ${e.message}`)
    return undefined
  }
}

// returns old value (if any)
export const setItem = (name, value) => {
  if (!enabled || value == null) return undefined
  const oldValue = getItem(name)
  if (value == null) return oldValue
  try {
    storage.setItem(name, value)
    return oldValue
  }
  catch(e) {
    console.log(`${storename} exception: ${e.message}`)
    return undefined
  }
}

// returns old value (if any)
export const setItemOnce = (name, value) => {
  if (!enabled || value == null) return undefined
  const oldValue = getItem(name)
  if (oldValue != null) return oldValue
  try {
    storage.setItem(name, value)
    return oldValue
  }
  catch(e) {
    console.log(`${storename} exception: ${e.message}`)
    return undefined
  }
}

export const getInt = name => {
  if (!enabled) return undefined
  try {
    let value = storage.getItem(name)
    if (value != null) value = parseInt(value)
    return value
  }
  catch(e) {
    console.log(`${storename} exception: ${e.message}`)
    return undefined
  }
}

// returns old value (if any)
export const setInt = (name, value) => {
  if (!enabled || value == null) return undefined
  const oldValue = getInt(name)
  try {
    storage.setItem(name, parseInt(value))
    return oldValue
  }
  catch(e) {
    console.log(`${storename} exception: ${e.message}`)
    return undefined
  }
}

// returns old value (if any)
export const setIntOnce = (name, value) => {
  if (!enabled || value == null) return undefined
  const oldValue = getInt(name)
  if (oldValue != null) return oldValue
  try {
    storage.setItem(name, parseInt(value))
    return oldValue
  }
  catch(e) {
    console.log(`${storename} exception: ${e.message}`)
    return undefined
  }
}

export const increment = name => {
  if (!enabled) return undefined
  let value = getInt(name)
  if (value == null) value = 0
  value++
  setInt(name, value)
  return value
}

export const getDate = name => {
  if (!enabled) return undefined
  try {
    let value = getInt(name)
    if (value != null) return new Date(value)
    return value
  }
  catch(e) {
    console.log(`${storename} exception: ${e.message}`)
    return undefined
  }
}

// returns old value (if any)
export const setDate = (name, value) => {
  if (!enabled || value == null) return undefined
  const oldValue = getDate(name)
  try {
    value = Date.parse(value)
    setInt(name, value.valueOf())
    return oldValue
  }
  catch(e) {
    console.log(`${storename} exception: ${e.message}`)
    return undefined
  }
}

// returns old value (if any)
export const setDateOnce = (name, value) => {
  if (!enabled || value == null) return undefined
  const oldValue = getDate(name)
  if (oldValue != null) return oldValue
  try {
    value = Date.parse(value)
    setInt(name, value.valueOf())
    return oldValue
  }
  catch(e) {
    console.log(`${storename} exception: ${e.message}`)
    return undefined
  }
}

export const removeItem = (name) => {
  if (!enabled) return undefined
  try {
    storage.removeItem(name)
    return storage.getItem(name)
  }
  catch(e) {
    console.log(`${storename} exception: ${e.message}`)
    return undefined
  }
}

export default {enabled, getItem, setItem, setItemOnce, getInt, setInt, setIntOnce, increment, getDate, setDate, setDateOnce, removeItem}



// WEBPACK FOOTER //
// ./src/browser/session-storage.js